<template>
  <div class="wrapper">
    <invoices-details-modal ref="show_invoice_modal"></invoices-details-modal>
    <sweet-modal ref="due_date_modal" width="400">
      <div v-if="editing_invoice">
        <div class="form-group">Invoice #{{ editing_invoice.invoice_no }}</div>
        <div class="form-group">
          <datetime-picker v-model="new_due_date" :dateonly="true"></datetime-picker>
        </div>
        <div class="form-group">
          <button class="btn btn-primary" @click="spin($event, set_due_date, editing_invoice)">
            {{ 'set_due_date' | t }}
          </button>
        </div>
      </div>
    </sweet-modal>
    <sweet-modal ref="error_message_modal">
      <p>{{ current_invoice_error_message }}</p>
    </sweet-modal>
    <table class="table table-hover table-responsive w-100 d-block d-md-table">
      <thead>
        <tr>
          <th></th>
          <th>{{ 'id' | t | titlecase }}</th>
          <th v-if="show_customer">{{ 'customer' | t | titlecase }}</th>
          <th>{{ 'no' | t | titlecase }}</th>
          <th>{{ 'accounting_date' | t | titlecase }}</th>
          <th>
            <span>{{ 'due_date' | t | titlecase }}</span>
          </th>
          <th>{{ 'Acc' }}</th>
          <th>{{ 'subtotal' | t | titlecase }}</th>
          <th>{{ 'total' | t | titlecase }}</th>
          <th>{{ 'paid' | t | titlecase }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="invoice in invoices">
          <td>
            <span role="button" @click="spin($event, show_invoice, invoice)"
              ><span class="badge badge-primary" v-if="invoice.doc_type == 'invoice'">{{ 'IV' }}</span
              ><span class="badge badge-warning" v-if="invoice.doc_type == 'credit_memo'">{{ 'CM' }}</span></span
            >
          </td>
          <td>{{ invoice.id }}</td>
          <td v-if="show_customer">
            <p v-if="invoice.customer">
              <a
                class="hover-underline"
                @click="$router.push({ name: 'customers_show', params: { customer_id: invoice.customer.id } })"
                >{{ invoice.customer.name }}</a
              >
            </p>
          </td>
          <td>{{ invoice.invoice_no }}</td>
          <td>{{ (invoice.accounting_date || invoice.created_at) | date }}</td>
          <td>
            <div class="nowrap">
              <span :class="invoice.overdue ? 'text-danger' : ''">{{ invoice.due_date | date }}</span
              ><a
                class="btn btn-sm btn-outline-primary ml-2"
                v-if="!invoice.is_paid"
                @click="open_due_date_modal(invoice)"
                >{{ 'update' | t }}</a
              >
              <template v-if="invoice.overdue"
                ><br /><span>{{ invoice.notice_step | t }}</span></template
              >
            </div>
          </td>
          <td>
            <i class="fa fa-check" v-if="invoice.ext_ref"></i
            ><i
              class="fa fa-warning text-danger"
              v-else-if="invoice.error_message"
              role="button"
              @click="open_error_message_modal(invoice)"
            ></i>
          </td>
          <td>{{ invoice.sub_total_amount }} {{ invoice.currency }}</td>
          <td>{{ invoice.total_amount }} {{ invoice.currency }}</td>
          <td>
            <span class="mr-2"
              ><span class="badge badge-success" v-if="invoice.is_paid">Paid</span
              ><span class="badge badge-warning" v-else>Unpaid</span></span
            ><span v-if="invoice.doc_type == 'invoice'">
              <invoice-crediting-status :invoice="invoice"></invoice-crediting-status
            ></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import Api from '@/store/jsonapi';
import pdf_utils from './../../utils/pdf_utils';

export default {
  props: ['invoices', 'show_customer'],
  data: function () {
    return {
      editing_invoice: null,
      new_due_date: null,
      current_invoice_error_message: ''
    };
  },
  methods: {
    b64toBlob: pdf_utils.b64toBlob,
    open_due_date_modal(invoice) {
      this.editing_invoice = invoice;
      this.$refs.due_date_modal.open();
      this.new_due_date = invoice.due_date;
    },
    open_error_message_modal(invoice) {
      this.current_invoice_error_message = invoice.error_message;
      this.$refs.error_message_modal.open();
    },
    async set_due_date() {
      this.editing_invoice.due_date = this.new_due_date;
      await Api.update('invoices', {
        id: this.editing_invoice.id,
        due_date: this.editing_invoice.due_date
      });
      this.$refs.due_date_modal.close();
    },
    async show_invoice(invoice) {
      await Api.find('invoices', invoice.id, {
        fields: { invoices: 'base64,invoice_no' }
      }).then(({ data }) => {
        this.$refs.show_invoice_modal.open(data.base64);
      });
    },
    download: async function (invoice) {
      console.log('Click invoice');
      await Api.find('invoices', invoice.id, {
        fields: { invoices: 'base64,invoice_no' }
      }).then(({ data }) => {
        this.$refs.show_invoice_modal.open();
        this.showFile(this.b64toBlob(data.base64, 'application/pdf'), data.invoice_no + '');
      });
    }
  }
};
</script>

<style lang="css" scoped>
.nowrap {
  white-space: nowrap;
}
.wrapper >>> .sweet-modal.is-visible {
  overflow: visible;
}
</style>
